<div class="mockup-container">
  <div class="iphone-frame shadow-2xl">
    <!-- Dynamic Island -->
    <div class="dynamic-island"></div>

    @if (selectedPreviewCategory) {
    <div
      class="shrink-0 bg-white border-b border-slate-100 pt-8 px-4 pb-3 flex items-center justify-between min-h-[96px]"
    >
      <div class="flex items-center gap-3 min-w-0">
        <button
          type="button"
          class="size-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0"
          aria-label="Back to home preview"
          (click)="closeCategoryPreview()"
        >
          <i class="fi fi-rr-arrow-small-left text-xl text-slate-900"></i>
        </button>
        <div class="min-w-0">
          <h2 class="text-lg font-extrabold text-slate-900 truncate">
            {{ selectedPreviewCategory.name || 'Products' }}
          </h2>
          <div class="flex items-center gap-1 mt-0.5">
            <i class="fi fi-sr-bolt text-[10px] text-amber-500"></i>
            <span class="text-[10px] font-bold text-slate-500"
              >Delivery in 10 mins</span
            >
          </div>
        </div>
      </div>
      <div
        class="size-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0"
      >
        <i class="fi fi-br-search text-base text-slate-900"></i>
      </div>
    </div>
    } @else if (showCategoriesPreview) {
    <div
      class="shrink-0 bg-white pt-8 px-4 pb-4 border-b border-slate-100 flex items-center justify-between min-h-[82px]"
    >
      <h2 class="text-xl font-extrabold text-slate-900">Categories</h2>
      <div
        class="size-10 rounded-full bg-slate-100 flex items-center justify-center"
      >
        <i class="fi fi-br-search text-lg text-slate-900"></i>
      </div>
    </div>
    } @else if (previewMode === 'collection') {
      @if (collectionBannerUrl) {
        <div
          class="relative shrink-0 overflow-hidden bg-slate-100"
          [ngClass]="{
            'h-[185px]': collectionType === 'brand',
            'h-[270px]': collectionType === 'campaign',
            'h-[238px]': collectionType === 'collection'
          }"
        >
          <img
            [src]="collectionBannerUrl"
            class="absolute inset-0 w-full h-full object-cover"
            [alt]="collectionTitle"
          />
          <div class="absolute left-4 right-4 top-10 flex items-center justify-between z-20">
            <button class="size-11 rounded-full bg-white/95 shadow-md flex items-center justify-center text-slate-900" aria-label="Back">
              <i class="fi fi-rr-arrow-small-left text-2xl"></i>
            </button>
            <button class="size-11 rounded-full bg-white/95 shadow-md flex items-center justify-center text-slate-900" aria-label="Search">
              <i class="fi fi-br-search text-lg"></i>
            </button>
          </div>

          @if (collectionType === 'campaign') {
            <div
              class="absolute inset-0 z-10 flex flex-col justify-end px-5 pb-6 text-white"
              style="background: linear-gradient(to bottom, transparent 24%, rgba(0,0,0,.8) 100%)"
            >
              <span class="mb-2 w-fit rounded-full bg-emerald-600 px-2.5 py-1 text-[9px] font-black tracking-widest">SPECIAL CAMPAIGN</span>
              <h2 class="max-w-[88%] text-[28px] leading-8 font-black tracking-tight">{{ collectionTitle || 'Campaign' }}</h2>
              <div class="mt-2 flex items-center gap-1.5 text-[11px] font-bold">
                <i class="fi fi-sr-bolt text-xs"></i>
                <span>Shop now · Delivery in 10 minutes</span>
              </div>
            </div>
          }
        </div>

        @if (collectionType !== 'campaign') {
          <div
            class="relative z-20 flex shrink-0 items-center gap-3 border-b border-slate-100 px-4 py-3.5"
            [class.-mt-7]="collectionType === 'brand'"
            [class.mx-4]="collectionType === 'brand'"
            [class.rounded-3xl]="collectionType === 'brand'"
            [class.border]="collectionType === 'brand'"
            [class.shadow-lg]="collectionType === 'brand'"
            [style.background]="collectionBackgroundColor"
          >
            @if (collectionIconUrl) {
              <div
                class="shrink-0 overflow-hidden border border-slate-200 bg-white"
                [ngClass]="collectionType === 'brand' ? 'size-[70px] rounded-[20px]' : 'size-[58px] rounded-2xl'"
              >
                <img [src]="collectionIconUrl" class="h-full w-full object-contain" [alt]="collectionTitle + ' icon'" />
              </div>
            }
            <div class="min-w-0 flex-1">
              @if (collectionType === 'brand') {
                <p class="mb-0.5 text-[9px] font-black tracking-[0.12em] text-emerald-700">OFFICIAL BRAND STORE</p>
              }
              <h2 class="truncate text-xl font-black" [style.color]="collectionTextColor">{{ collectionTitle || 'Collection' }}</h2>
              <div class="mt-1.5 flex w-fit items-center gap-1 rounded-full bg-emerald-50 px-2 py-1 text-[10px] font-extrabold text-emerald-800">
                <i class="fi fi-sr-bolt text-[10px] text-emerald-600"></i>
                <span>{{ collectionType === 'brand' ? 'Authentic products · 10 min delivery' : 'Delivery in 10 minutes' }}</span>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="shrink-0 bg-white border-b border-slate-100 pt-7 px-4 pb-2 flex items-center gap-3 min-h-[92px]">
          <div class="size-[42px] rounded-full bg-slate-100 flex items-center justify-center shrink-0">
            <i class="fi fi-rr-arrow-small-left text-xl text-slate-900"></i>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-[11px] font-extrabold uppercase text-slate-500">
              {{ collectionType === 'brand' ? 'Brand store' : collectionType === 'campaign' ? 'Special campaign' : 'Collection' }}
            </p>
            <h2 class="text-lg font-extrabold text-slate-900 truncate">{{ collectionTitle || 'Collection' }}</h2>
          </div>
          <div class="size-[42px] rounded-full bg-slate-100 flex items-center justify-center shrink-0">
            <i class="fi fi-br-search text-base text-slate-900"></i>
          </div>
        </div>
      }
    } @else {
    <!-- App Header -->
    <div
      class="shrink-0 transition-all duration-500 overflow-hidden"
      [style.background]="headerStyle"
    >
      <!-- Top Padding for Status Bar -->
      <div class="h-7 w-full"></div>

      <!-- Main Header Content -->
      <div class="px-4">
        <!-- Location & Profile Row -->
        <div class="flex justify-between items-center pb-3 pt-3">
          <div class="flex items-center gap-1.5 min-w-0">
            <i
              class="fi fi-sr-bolt text-[30px] shrink-0"
              [style.color]="config.secondaryColor"
            ></i>
            <div class="flex flex-col">
              <div class="flex items-center gap-1 group cursor-pointer">
                <h2
                  class="text-[28px] leading-8 font-extrabold tracking-tight whitespace-nowrap"
                  [style.color]="config.headerTextColor"
                >
                  10 min
                </h2>
              </div>
              <div class="flex items-center min-w-0 mt-1">
                <p
                  class="text-[13px] leading-4 font-extrabold truncate max-w-[245px]"
                  [style.color]="config.headerTextColor"
                >
                  Azad Nagar, Mumbai
                </p>
                <i
                  class="fi fi-rr-angle-small-down text-base ml-1"
                  [style.color]="config.headerTextColor"
                ></i>
              </div>
            </div>
          </div>
          <div
            class="size-[34px] rounded-full bg-white flex items-center justify-center border border-slate-400 shadow-sm overflow-hidden shrink-0"
          >
            <i class="fi fi-rr-user text-base text-black"></i>
          </div>
        </div>

        <!-- Search Bar -->
        <div
          class="search-container h-[42px] flex items-center px-3 rounded-[13px] shadow-md relative group"
          [style.background]="config.backgroundColor"
        >
          <i
            class="fi fi-br-search text-sm"
            [style.color]="config.searchIconColor"
          ></i>
          <span
            class="text-xs font-bold opacity-40 flex-1 truncate"
            [style.color]="config.searchPlaceholderColor"
          >
            {{ activeSearchPlaceholder }}
          </span>
        </div>
        <!-- Sticky Navigation Tabs -->
        <div
          class="glass-header z-20 pt-[5px] flex overflow-x-auto no-scrollbar shrink-0"
        >
          @for (tab of tabs; track tab.id) {
          <div
            class="preview-shortcut flex flex-col items-center shrink-0 min-w-[62px] cursor-pointer"
            [class.tab-active]="activeTabId === tab.id"
            (click)="activeTabId = tab.id"
            (keyup.enter)="activeTabId = tab.id"
            tabindex="0"
            role="button"
          >
            <div
              class="size-[42px] rounded-full flex items-center justify-center overflow-hidden grayscale"
              [class.grayscale-0]="activeTabId === tab.id"
            >
              @if (tab.icon_url) {
              <img
                [src]="tab.icon_url"
                class="size-[30px] object-contain"
                [alt]="tab.name"
              />
              } @else {
              <div class="text-[6px] font-black opacity-20">ICON</div>
              }
            </div>
            <span
              class="text-xs leading-[15px] font-bold text-center"
              [style.color]="
                activeTabId === tab.id ? config.primaryColor : '#64748b'
              "
            >
              {{ tab.name }}
            </span>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Content Area Container -->
    <div
      class="flex-1 overflow-hidden flex flex-col bg-[#F8F9FB]"
      [style.background]="config.backgroundColor"
    >
      @if (selectedPreviewCategory) {
      <div class="flex-1 min-h-0 flex bg-white">
        <div
          class="w-[82px] shrink-0 overflow-y-auto no-scrollbar border-r border-slate-200 bg-white py-2"
        >
          @for (category of categoryPreviewItems; track category.category_id) {
          <button
            type="button"
            class="w-full py-2.5 px-1.5 border-l-[3px] border-transparent flex flex-col items-center transition-colors"
            [class.bg-slate-50]="
              selectedPreviewCategory.category_id === category.category_id
            "
            [class.!border-l-green-700]="
              selectedPreviewCategory.category_id === category.category_id
            "
            (click)="selectPreviewCategory(category)"
          >
            <div
              class="size-12 rounded-full bg-slate-100 border border-transparent flex items-center justify-center overflow-hidden"
              [class.!border-green-700]="
                selectedPreviewCategory.category_id === category.category_id
              "
              [class.bg-white]="
                selectedPreviewCategory.category_id === category.category_id
              "
            >
              @if (category.image_url) {
              <img
                [src]="category.image_url"
                class="size-9 object-contain"
                [alt]="category.name"
              />
              } @else {
              <span class="text-sm font-black text-green-700">{{
                (category.name || 'C').slice(0, 1)
              }}</span>
              }
            </div>
            <span
              class="mt-1.5 text-[9px] leading-[12px] font-bold text-slate-500 text-center line-clamp-2"
              [class.!text-green-700]="
                selectedPreviewCategory.category_id === category.category_id
              "
              >{{ category.name }}</span
            >
          </button>
          }
        </div>

        <div class="flex-1 min-w-0 overflow-y-auto no-scrollbar p-2.5">
          <div class="flex items-center justify-between gap-2 mb-3">
            <div class="min-w-0">
              <h3 class="text-sm font-black text-slate-900 truncate">
                {{ selectedPreviewCategory.name || 'Products' }}
              </h3>
              <p class="text-[9px] font-semibold text-slate-500 mt-0.5">
                {{
                  categoryPreviewLoading
                    ? 'Loading products…'
                    : categoryPreviewProducts.length + ' products'
                }}
              </p>
            </div>
            <div
              class="shrink-0 rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-[9px] font-bold text-slate-700"
            >
              ↕ Sort
            </div>
          </div>

          @if (categoryPreviewLoading) {
          <div class="grid grid-cols-2 gap-2">
            @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
            <div
              class="h-[165px] rounded-xl border border-slate-100 bg-slate-50 animate-pulse"
            ></div>
            }
          </div>
          } @else if (categoryPreviewProducts.length) {
          <div class="grid grid-cols-2 gap-2">
            @for (product of categoryPreviewProducts; track product.id) {
            <div
              class="min-w-0 rounded-xl border border-slate-200 bg-white overflow-hidden"
            >
              <div class="relative h-[105px] bg-slate-50 p-2">
                <img
                  [src]="product.image_url"
                  class="size-full object-contain"
                  [alt]="product.name"
                />
                <span
                  class="absolute right-1.5 bottom-1.5 min-w-10 h-7 rounded-lg border border-green-700 bg-white px-2 flex items-center justify-center text-[9px] font-black text-green-700"
                  >ADD</span
                >
              </div>
              <div class="p-2">
                <p
                  class="text-[10px] leading-[13px] font-extrabold text-slate-900 line-clamp-2 min-h-[26px]"
                >
                  {{ product.name }}
                </p>
                <p class="text-[8px] text-slate-500 mt-1 truncate">
                  {{ product.unit }}
                </p>
                <p class="text-[11px] font-black text-slate-900 mt-1">
                  ₹{{ product.price }}
                </p>
              </div>
            </div>
            }
          </div>
          } @else {
          <div
            class="min-h-52 rounded-2xl border border-slate-200 bg-white px-4 flex flex-col items-center justify-center text-center"
          >
            <i class="fi fi-rs-box-open text-2xl text-slate-300"></i>
            <p class="mt-2 text-xs font-black text-slate-700">
              No products found
            </p>
            <p class="mt-1 text-[9px] text-slate-400">
              Try another category from the left.
            </p>
          </div>
          }
        </div>
      </div>
      } @else if (showCategoriesPreview) {
      <div class="flex-1 overflow-y-auto native-scroll no-scrollbar bg-white pb-8">
        @for (group of categoryListPreviewGroups; track group.name) {
        <section class="px-4 pt-5">
          <h3 class="text-base font-extrabold text-slate-900 mb-3">
            {{ group.name }}
          </h3>
          <div class="grid grid-cols-4 gap-x-2.5 gap-y-3">
            @for (category of group.children; track category.category_id) {
            <button
              type="button"
              class="min-w-0 flex flex-col items-center active:scale-95 transition-transform"
              (click)="
                openCategoryPreview(category, group.children, 'categories')
              "
            >
              <div
                class="w-full aspect-[1/1.15] rounded-t-full rounded-b-lg overflow-hidden flex items-center justify-center"
                [style.background]="
                  ['#FDE2E4', '#FFF1E6', '#DFE7FD', '#E2ECE9', '#F0EFEB'][
                    $index % 5
                  ]
                "
              >
                @if (category.image_url) {
                <img
                  [src]="category.image_url"
                  class="size-full object-contain"
                  [alt]="category.name"
                />
                } @else {
                <span class="text-lg font-black text-slate-400">{{
                  category.name.slice(0, 1)
                }}</span>
                }
              </div>
              <span
                class="mt-1.5 text-[9px] leading-[12px] font-bold text-slate-800 text-center line-clamp-2"
                >{{ category.name }}</span
              >
            </button>
            }
          </div>
        </section>
        }
        @if (!categoryListPreviewGroups.length) {
        <div class="h-64 flex flex-col items-center justify-center px-6 text-center">
          <i class="fi fi-rr-apps text-2xl text-slate-300"></i>
          <p class="mt-2 text-xs font-black text-slate-700">
            No categories available
          </p>
        </div>
        }
        <div class="pt-8 pb-3 text-center">
          <span class="text-xs font-black text-green-700">Supidoo</span>
        </div>
      </div>
      } @else {
      <!-- Main Scrollable Sections -->
      <div class="flex-1 overflow-y-auto native-scroll pb-10 no-scrollbar">
        @for (section of sections; track section.id) {
        <div
          class="relative group"
          [style.opacity]="section.is_active ? 1 : 0.4"
          [class.hidden]="!isCustomerRenderedSection(section.type)"
        >
          <!-- Context Menu for Admin -->
          <div
            class="absolute -top-3 -right-3 hidden group-hover:flex gap-1 z-30 scale-90 peer-hover:scale-100"
          >
            <div
              class="bg-white/90 backdrop-blur-md shadow-xl border border-black/5 p-1 rounded-xl flex gap-1"
            >
              <button
                class="p-1.5 hover:bg-slate-50 text-slate-400 hover:text-primary rounded-lg transition-colors"
                (click)="sectionSelected.emit(section.id)"
              >
                <i class="fi fi-rr-edit-alt text-xs"></i>
              </button>
            </div>
          </div>

          @switch (normalizeSectionType(section.type)) { @case ('banner') { @let
          banner = getSectionConfig(section).banners?.[0];
          <div
            class="mt-4 mb-2 bg-slate-100 overflow-hidden relative group/banner-preview"
          >
            <img
              [src]="
                banner?.image_url ||
                'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?q=80&w=800'
              "
              class="w-full h-auto object-contain transition-transform duration-700 group-hover/banner-preview:scale-[1.01]"
              alt="Banner"
            />

            <!-- Banner Content -->
            <div
              class="absolute inset-0 p-4 w-[58%] flex flex-col justify-between"
            >
              @if (banner?.title) {
              <h3
                class="text-[28px] font-extrabold leading-[34px] mb-1"
                [style.color]="banner.title_color || '#ffffff'"
              >
                {{ banner.title }}
              </h3>
              } @if (banner?.subtitle) {
              <p
                class="text-sm leading-5 font-extrabold uppercase opacity-90"
                [style.color]="banner.subtitle_color || '#ffffff'"
              >
                {{ banner.subtitle }}
              </p>
              } @if (banner?.cta_text) {
              <button
                class="w-fit min-h-10 px-4 py-2 rounded-xl text-sm font-extrabold transition-transform active:scale-95"
                [style.background-color]="banner.cta_bg_color || '#000000'"
                [style.color]="banner.cta_text_color || '#ffffff'"
              >
                {{ banner.cta_text }}
              </button>
              }
            </div>
          </div>
          @if ((getSectionConfig(section).banners || []).length > 1) {
          <div class="flex justify-center gap-1.5 mt-2 mb-2">
            <span class="w-4 h-1.5 rounded-full bg-green-700"></span>
            @for (_ of getSectionConfig(section).banners.slice(1); track $index)
            { <span class="size-1.5 rounded-full bg-slate-300"></span> }
          </div>
          } } @case ('offer_strip') { @let offer = getOfferStripConfig(section);
          <div
            class="w-full py-3 px-4 rounded-2xl flex items-center justify-between shadow-md border transition-all hover:scale-[1.02]"
            [style.background]="
              offer.background_color ||
              'linear-gradient(to right, #fbbf24, #fb923c)'
            "
            [style.color]="offer.text_color || '#ffffff'"
            [class.glass-effect]="offer.ui_type === 'glass'"
            [class.premium-glow]="offer.ui_type === 'premium'"
          >
            <div class="flex items-center gap-3">
              <div
                class="size-8 rounded-xl bg-white/20 backdrop-blur-md flex items-center justify-center ring-1 ring-white/30"
              >
                <i
                  class="fi {{
                    offer.icon || 'fi-ss-bolt-lightning'
                  }} text-white text-sm"
                ></i>
              </div>
              <div class="flex flex-col">
                <p
                  class="text-[11px] font-black leading-none uppercase tracking-tight"
                >
                  {{ offer.title || 'FLASH OFFER' }}
                </p>
                <p class="text-[9px] font-bold opacity-90 mt-1">
                  {{ offer.subtitle || 'Use code SUPIDOO100' }}
                </p>
              </div>
            </div>
            <button
              class="px-3 py-1.5 bg-white rounded-xl text-[9px] font-black shadow-sm shrink-0"
              [style.color]="offer.background_color || '#f97316'"
            >
              {{ offer.cta_text || 'COPY' }}
            </button>
          </div>
          } @case ('category_grid') {
          <div class="my-2">
            @for (group of getCategoryGroups(section); track group.parentId) {
            <div class="mb-[18px] px-4">
              <h4 class="text-lg font-extrabold text-slate-900 mb-3">
                {{ group.parentName }}
              </h4>
              <div class="grid grid-cols-4 gap-2">
                @for (cat of group.children; track cat.category_id) {
                <div
                  class="h-[108px] rounded-[14px] border border-slate-100 bg-[#F7FAF6] p-2 flex flex-col items-center justify-between group/cat transition-transform active:scale-95 cursor-pointer"
                  (click)="openCategoryPreview(cat, group.children)"
                  (keyup.enter)="openCategoryPreview(cat, group.children)"
                  tabindex="0"
                  role="button"
                >
                  <div
                    class="flex-1 w-full flex items-center justify-center overflow-hidden"
                  >
                    <img
                      [src]="cat.image_url"
                      class="w-[82%] h-[82%] object-contain"
                      alt=""
                    />
                  </div>
                  <span
                    class="text-[10px] font-bold text-slate-700 text-center leading-[14px] line-clamp-2 w-full mt-1"
                    >{{ cat.name }}</span
                  >
                </div>
                }
              </div>
            </div>
            }
          </div>
          } @case ('brand_grid') { @let brandsConfig =
          getBrandGridConfig(section);
          <div class="my-2">
            @if (brandsConfig.title) {
            <h4 class="text-lg font-extrabold text-slate-900 px-4 mb-3">
              {{ brandsConfig.title }}
            </h4>
            }
            <div class="flex overflow-x-auto no-scrollbar px-3">
              @for (brand of getBrandItems(section); track $index) {
              <div
                class="w-[120px] px-1.5 shrink-0 group/brand transition-transform active:scale-95"
              >
                <div
                  class="h-[116px] rounded-[14px] bg-[#F7FAF6] border border-[#E6ECE4] flex flex-col items-center justify-between p-2 transition-shadow relative overflow-hidden"
                >
                  @if (brand.image_url || brand.image) {
                  <img
                    [src]="brand.image_url || brand.image"
                    class="w-[84%] h-[78%] object-contain hover:scale-105 transition-transform"
                    alt=""
                  />
                  } @else {
                  <i class="fi fi-rs-star text-slate-200 text-xl"></i>
                  }
                  <span
                    class="text-xs font-extrabold text-slate-700 leading-[15px] line-clamp-2 text-center"
                    >{{ brand.name }}</span
                  >
                </div>
              </div>
              }
            </div>
          </div>
          } @case ('flash_sale') {
          <div
            class="bg-[#1C1C1C] rounded-[2rem] p-5 relative overflow-hidden shadow-2xl"
          >
            <div
              class="absolute -right-8 -top-8 size-32 bg-indigo-600/30 blur-3xl rounded-full"
            ></div>
            <div class="flex justify-between items-center mb-5 relative z-10">
              <div class="flex items-center gap-2.5">
                <div
                  class="size-10 rounded-2xl bg-amber-400 flex items-center justify-center shadow-[0_0_20px_rgba(251,191,36,0.3)]"
                >
                  <i class="fi fi-sr-bolt text-black text-lg"></i>
                </div>
                <div>
                  <h4
                    class="text-white font-black text-base leading-none tracking-tight"
                  >
                    Flash Sale
                  </h4>
                  <div class="flex items-center gap-1.5 mt-1 timer-pulse">
                    <div class="size-1 rounded-full bg-rose-500"></div>
                    <span
                      class="text-[9px] font-black text-white/50 uppercase tracking-widest"
                      >Ending in 12m 45s</span
                    >
                  </div>
                </div>
              </div>
              <i class="fi fi-sr-arrow-right text-white/20"></i>
            </div>
            <div class="flex gap-4 overflow-x-auto no-scrollbar relative z-10">
              @for (item of getFlashSaleItems(section); track $index) {
              <div
                class="w-32 bg-white/5 border border-white/10 rounded-2xl p-2.5 shrink-0 hover:bg-white/10 transition-colors"
              >
                <div
                  class="aspect-square bg-white rounded-xl mb-2.5 flex items-center justify-center p-3 shadow-inner"
                >
                  <div
                    class="size-full bg-slate-100 rounded-lg animate-pulse"
                  ></div>
                </div>
                <p
                  class="text-[10px] font-bold text-white/90 truncate leading-tight"
                >
                  {{ item.name }}
                </p>
                <div class="flex items-center justify-between mt-1.5">
                  <span class="text-xs font-black text-white"
                    >₹{{ item.price }}</span
                  >
                  <span
                    class="text-[8px] font-bold text-rose-500 bg-rose-500/10 px-1.5 py-0.5 rounded-lg"
                    >-{{ item.discount }}</span
                  >
                </div>
              </div>
              }
            </div>
          </div>
          } @case ('product_shelf') { @let shelf = getSectionConfig(section);
          @let shelfUiType = getProductShelfUiType(shelf);
          <div
            class="mb-4 pt-3 pb-3"
            [style.background]="shelf.background_color || '#ffffff'"
          >
            <div class="flex justify-between items-center px-4 mb-2 gap-2">
              <div class="flex items-center gap-2">
                <h4
                  class="text-lg font-extrabold tracking-tight"
                  [style.color]="shelf.text_color || '#0f172a'"
                >
                  {{ shelf.title || 'Must Haves' }}
                </h4>
              </div>
              @if (shouldShowShelfSeeAll(section)) {
              <span class="text-[13px] font-extrabold text-primary shrink-0"
                >See all <i class="fi fi-rr-angle-small-right"></i
              ></span>
              }
            </div>
            @if (getShelfProducts(section).length) {
              @if (shelfUiType === 'grid') {
              <div class="flex gap-2 px-4 overflow-x-auto no-scrollbar">
                @for (p of getShelfProducts(section).slice(0, 6); track p.id || $index) {
                <div class="w-[114px] shrink-0">
                  <ng-container *ngTemplateOutlet="customerProductCard; context: { product: p, imageHeight: 124 }" />
                </div>
                }
              </div>
              } @else {
              <div class="flex gap-2 px-4 overflow-x-auto no-scrollbar items-start">
                @for (chunk of splitIntoChunks(getShelfProducts(section).slice(0, 6), 2); track $index) {
                <div class="w-[114px] shrink-0 flex flex-col gap-2">
                  @for (p of chunk; track p.id || $index) {
                  <ng-container *ngTemplateOutlet="customerProductCard; context: { product: p, imageHeight: 124 }" />
                  }
                </div>
                }
              </div>
              }
            } @else if (isShelfLoading(section.id)) {
              <div
                class="mx-4 min-h-32 flex flex-col items-center justify-center text-slate-400"
              >
                <span
                  class="loading loading-spinner loading-sm text-primary"
                ></span>
                <span class="text-[10px] font-bold mt-2"
                  >Loading products from query…</span
                >
              </div>
              } @else {
              <div
                class="mx-4 min-h-28 rounded-xl border border-dashed border-slate-200 bg-slate-50 flex flex-col items-center justify-center text-center px-4"
              >
                <i class="fi fi-rs-box-open text-xl text-slate-300"></i>
                <span class="text-[10px] font-black text-slate-400 mt-2">
                  {{
                    didShelfFail(section.id)
                      ? 'Could not load query products'
                      : 'No products match this query'
                  }}
                </span>
              </div>
              }
          </div>
          } @case ('collection_banner') { @let col =
          getCollectionBannerConfig(section);
          <div
            class="collection-banner-container mb-3 overflow-hidden transition-all duration-500"
            [class.mx-3]="!col.edge_to_edge"
            [class.rounded-3xl]="!col.edge_to_edge"
            [style.background]="getCollectionSurface(col)"
          >
            @if (col.show_top_border) {
            <div
              class="collection-edge collection-edge-top"
              [ngStyle]="getCollectionEdgeStyle(col, 'top')"
            ></div>
            }
            @if (col.render_main_banner && collectionHeroImage(col)) {
            <div class="relative overflow-hidden">
              <img
                [src]="collectionHeroImage(col)"
                class="block w-full h-auto object-contain object-center"
                alt=""
              />
            </div>
            } @else if (col.title || col.subtitle) {
            <div class="px-4 pt-3 pb-1" [style.text-align]="col.text_align || 'center'">
              @if (col.subtitle) {
              <p class="text-[9px] font-black uppercase tracking-[0.18em]" [style.color]="col.subtitle_color || col.text_color || '#5A2A0A'">
                {{ col.subtitle }}
              </p>
              }
              @if (col.title) {
              <h3 class="text-xl font-black leading-tight" [style.color]="col.title_color || col.text_color || '#5A2A0A'">{{ col.title }}</h3>
              }
            </div>
            }

            <ng-template #collectionTextTile let-item="item" let-fill="fill">
              @switch (col.text_style || 'teej') {
              @case ('overlay') {
              <div class="relative h-full min-h-[86px] rounded-[1.05rem] overflow-hidden bg-white" [style.background]="item.background_color || '#fff'">
                <img [src]="item.image_url" class="absolute inset-0 size-full object-contain" alt="" />
                @if (hasCollectionCardTitle(item)) {
                <p class="relative z-10 p-1.5 text-[9px] font-black text-white drop-shadow line-clamp-2">{{ item.title }}</p>
                }
              </div>
              }
              @case ('caption') {
              <div class="relative h-full min-h-[86px] rounded-[1.05rem] overflow-hidden bg-white" [style.background]="item.background_color || '#fff'">
                <img [src]="item.image_url" class="absolute inset-0 size-full object-contain" alt="" />
                @if (hasCollectionCardTitle(item)) {
                <div class="absolute inset-x-0 bottom-0 bg-white/90 px-1.5 py-1">
                  <p class="text-[8px] font-black line-clamp-2" [style.color]="item.text_color || '#111111'">{{ item.title }}</p>
                </div>
                }
              </div>
              }
              @case ('pill') {
              <div class="relative h-full min-h-[86px] rounded-[1.05rem] overflow-hidden bg-white" [style.background]="item.background_color || '#fff'">
                <img [src]="item.image_url" class="absolute inset-0 size-full object-contain" alt="" />
                @if (hasCollectionCardTitle(item)) {
                <span class="absolute top-1.5 left-1.5 max-w-[80%] rounded-full bg-white px-1.5 py-0.5 text-[7px] font-black shadow-sm line-clamp-1" [style.color]="item.text_color || '#111111'">{{ item.title }}</span>
                }
              </div>
              }
              @default {
              <div class="h-full rounded-[1.05rem] bg-white p-2 flex flex-col" [style.background]="item.background_color || '#fff'">
                @if (hasCollectionCardTitle(item)) {
                <p class="text-[10px] font-black leading-[12px] mb-1.5 line-clamp-2" [style.color]="item.text_color || '#111111'">{{ item.title }}</p>
                }
                <img [src]="item.image_url" class="w-full object-contain" [ngClass]="fill ? 'flex-1 min-h-[56px]' : 'h-[86px]'" alt="" />
              </div>
              }
              }
            </ng-template>

            @switch (col.layout_type) {
            @case ('hero_mosaic') {
            <div class="grid grid-cols-[1.2fr_1fr] gap-2 h-[228px] p-2.5">
              @if (col.items.length) {
              @let heroItem = col.items[0];
              <div class="min-h-0">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: heroItem, fill: true }" />
              </div>
              }
              <div class="grid grid-cols-2 grid-rows-2 gap-2 min-h-0">
                @for (item of col.items.slice(1, 5); track $index) {
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: true }" />
                }
              </div>
            </div>
            }
            @case ('overlay_cards') {
            <div class="flex gap-2 overflow-x-auto no-scrollbar px-2.5 py-2.5">
              @for (item of col.items.slice(0, 4); track $index) {
              <div class="w-[118px] shrink-0">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: false }" />
              </div>
              }
            </div>
            }
            @case ('bento_grid') {
            <div class="grid grid-cols-3 gap-2 p-2.5">
              @for (item of col.items.slice(0, 6); track $index) {
              <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: false }" />
              }
            </div>
            }
            @case ('horizontal_carousel') {
            <div class="flex gap-2 overflow-x-auto no-scrollbar px-2.5 py-2.5">
              @for (item of col.items; track $index) {
              <div class="w-[72%] shrink-0 h-[168px]">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: true }" />
              </div>
              }
            </div>
            }
            @case ('left_hero') {
            <div class="grid grid-cols-[1.35fr_1fr] gap-2 h-[228px] p-2.5">
              @if (col.items.length) {
              @let heroItem = col.items[0];
              <div class="min-h-0">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: heroItem, fill: true }" />
              </div>
              }
              <div class="grid grid-rows-3 gap-2 min-h-0">
                @for (item of col.items.slice(1, 4); track $index) {
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: true }" />
                }
              </div>
            </div>
            }
            @case ('glassmorphism') {
            <div class="grid grid-cols-2 gap-2 p-2.5">
              @for (item of col.items.slice(0, 4); track $index) {
              <div class="h-[108px]">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: true }" />
              </div>
              }
            </div>
            }
            @case ('spotlight') {
            <div class="flex gap-2 overflow-x-auto no-scrollbar px-2.5 py-2.5">
              @for (item of col.items.slice(0, 4); track $index) {
              <div class="w-[124px] shrink-0 min-h-[148px]">
                <ng-container *ngTemplateOutlet="collectionTextTile; context: { item: item, fill: true }" />
              </div>
              }
            </div>
            }
            @case ('product_picks') {
            <div class="px-4 py-2">
              <div class="flex gap-2 overflow-x-auto no-scrollbar">
                @if (col.product_display_style !== 'two_row') {
                  @for (product of getShelfProducts(section).slice(0, 6); track $index) {
                  <div class="w-[114px] shrink-0">
                    <ng-container *ngTemplateOutlet="customerProductCard; context: { product: product, imageHeight: 128 }" />
                  </div>
                  } @empty {
                  <p class="text-[9px] font-bold opacity-60 px-1 col-span-3 text-center py-4 text-slate-400">Pick a category to preview products</p>
                  }
                } @else {
                  @for (chunk of splitIntoChunks(getShelfProducts(section).slice(0, 6), 2); track $index) {
                    <div class="flex flex-col gap-2 w-[114px] shrink-0">
                      @for (product of chunk; track $index) {
                        <ng-container *ngTemplateOutlet="customerProductCard; context: { product: product, imageHeight: 128 }" />
                      }
                    </div>
                  } @empty {
                  <p class="text-[9px] font-bold opacity-60 px-1 text-center py-4 text-slate-400 w-full">Pick a category to preview products</p>
                  }
                }
              </div>
            </div>
            }
            @case ('category_essentials') {
            <div class="py-2">
              <div class="flex gap-2 overflow-x-auto no-scrollbar px-2.5 mb-2">
                @for (cat of (col.categories || []).slice(0, 6); track $index) {
                @switch (col.chip_style || 'circle') {
                @case ('pill') {
                <div class="h-9 shrink-0 rounded-full px-2 flex items-center gap-1.5 border"
                  [ngClass]="$index === 0 ? 'bg-white' : 'bg-white/15 border-white/25'"
                  [style.border-color]="$index === 0 ? col.chip_selected_border_color : null">
                  <div class="size-6 rounded-full overflow-hidden bg-slate-100">
                    <img [src]="cat.image_url" class="size-full object-cover" alt="" />
                  </div>
                  <p class="text-[8px] font-black max-w-[72px] line-clamp-1" [style.color]="$index === 0 ? col.chip_selected_text_color : col.chip_unselected_text_color">{{ cat.name }}</p>
                </div>
                }
                @case ('tile') {
                <div class="w-[68px] shrink-0 rounded-[18px] px-1 pt-1 pb-1.5 flex flex-col items-center" [class.bg-white]="$index === 0">
                  <div class="size-14 rounded-2xl bg-white overflow-hidden border-2" [class.border-transparent]="$index !== 0"
                    [style.border-color]="$index === 0 ? col.chip_selected_border_color : null">
                    <img [src]="cat.image_url" class="size-full object-cover" alt="" />
                  </div>
                  <p class="mt-1 text-[7px] font-black text-center line-clamp-2" [style.color]="$index === 0 ? col.chip_selected_text_color : col.chip_unselected_text_color">{{ cat.name }}</p>
                </div>
                }
                @case ('bar') {
                <div class="h-8 shrink-0 rounded-full border px-3 flex items-center"
                  [class.bg-white]="$index === 0"
                  [ngClass]="$index !== 0 ? 'bg-white/15 border-white/25' : ''"
                  [style.border-color]="$index === 0 ? col.chip_selected_border_color : null">
                  <p class="text-[8px] font-black" [style.color]="$index === 0 ? col.chip_selected_text_color : col.chip_unselected_text_color">{{ cat.name }}</p>
                </div>
                }
                @case ('framed') {
                <div class="w-[72px] min-h-[92px] shrink-0 rounded-[18px] border p-1 flex flex-col items-center"
                  [ngClass]="$index === 0 ? 'bg-white' : 'border-white/25 bg-white/10'"
                  [style.border-color]="$index === 0 ? col.chip_selected_border_color : null">
                  <div class="w-full h-14 rounded-[14px] overflow-hidden bg-slate-100">
                    <img [src]="cat.image_url" class="size-full object-cover" alt="" />
                  </div>
                  <p class="mt-1 px-0.5 text-[8px] font-black text-center leading-tight line-clamp-2" [style.color]="$index === 0 ? col.chip_selected_text_color : col.chip_unselected_text_color">{{ cat.name }}</p>
                </div>
                }
                @default {
                <div class="w-[62px] shrink-0 rounded-[18px] pt-1 pb-1.5 flex flex-col items-center" [class.bg-white]="$index === 0">
                  <div class="size-12 rounded-full bg-white overflow-hidden border-2" [class.border-transparent]="$index !== 0"
                    [style.border-color]="$index === 0 ? col.chip_selected_border_color : null">
                    <img [src]="cat.image_url" class="size-full object-cover" alt="" />
                  </div>
                  <p class="mt-1 text-[7px] font-black text-center line-clamp-2" [style.color]="$index === 0 ? col.chip_selected_text_color : col.chip_unselected_text_color">{{ cat.name }}</p>
                </div>
                }
                }
                }
              </div>
              <div class="flex gap-2 overflow-x-auto no-scrollbar px-2.5">
                @for (product of getShelfProducts(section).slice(0, 6); track $index) {
                <div class="w-[138px] shrink-0">
                  <ng-container *ngTemplateOutlet="customerProductCard; context: { product: product, imageHeight: 128 }" />
                </div>
                }
              </div>
            </div>
            }
            }

            @if (col.layout_type !== 'product_picks' && col.layout_type !== 'category_essentials' && getShelfProducts(section).length > 0) {
            <div class="px-2.5 py-2">
              <div class="flex gap-2 overflow-x-auto no-scrollbar">
                @for (product of getShelfProducts(section).slice(0, 6); track $index) {
                <div class="w-[138px] shrink-0">
                  <ng-container *ngTemplateOutlet="customerProductCard; context: { product: product, imageHeight: 128 }" />
                </div>
                }
              </div>
            </div>
            }

            @if (col.show_bottom_offer && col.bottom_offer?.title) {
            @switch (col.bottom_offer?.design || 'card') {
            @case ('ribbon') {
            <div class="px-3 py-2 flex flex-col items-center justify-center relative overflow-hidden"
                 [style.background]="col.bottom_border_color || col.border_color || '#FFEAEA'">
              <div class="flex items-center gap-2 w-full justify-center">
                <div class="flex-1 min-w-0 text-center">
                  <p class="text-[11px] font-black uppercase tracking-[0.12em] truncate drop-shadow-sm" [style.color]="col.title_color || col.text_color || '#000'">{{ col.bottom_offer?.title }}</p>
                  @if (col.bottom_offer?.subtitle) {
                  <p class="text-[9px] font-bold opacity-80 truncate mt-0.5" [style.color]="col.title_color || col.text_color || '#000'">{{ col.bottom_offer?.subtitle }}</p>
                  }
                </div>
              </div>
            </div>
            }
            @case ('powered') {
            <div class="px-3 py-3 text-center flex flex-col items-center">
              <p class="text-[8px] font-black uppercase tracking-[0.2em] opacity-80 drop-shadow-sm" [style.color]="col.title_color || col.text_color || '#FFF6E4'">{{ col.bottom_offer?.title || 'Powered by' }}</p>
              <div class="mt-1 flex items-center justify-center gap-2">
                <span class="h-[1px] w-4 bg-black/10 mix-blend-overlay"></span>
                <p class="text-[12px] leading-none font-black drop-shadow-sm" [style.color]="col.title_color || col.text_color || '#FFF6E4'">{{ col.bottom_offer?.subtitle }}</p>
                <span class="h-[1px] w-4 bg-black/10 mix-blend-overlay"></span>
              </div>
            </div>
            }
            @case ('ticket') {
            <div class="mx-2.5 mb-3 rounded-xl border-2 border-dashed bg-white/20 backdrop-blur-md px-3 py-2 flex items-center justify-between shadow-[0_2px_12px_rgba(0,0,0,0.04)] relative" [style.border-color]="col.border_color || 'rgba(0,0,0,0.1)'">
              <div class="absolute -left-2 top-1/2 -translate-y-1/2 h-4 w-2 rounded-r-full shadow-inner" [style.background]="getCollectionSurface(col)"></div>
              <div class="absolute -right-2 top-1/2 -translate-y-1/2 h-4 w-2 rounded-l-full shadow-inner" [style.background]="getCollectionSurface(col)"></div>

              <div class="flex flex-1 min-w-0 items-center justify-between pl-1.5 pr-1.5">
                <div class="flex-1 min-w-0">
                  <p class="text-[11px] font-black truncate drop-shadow-sm text-slate-800" [style.color]="col.title_color || col.text_color || '#111'">{{ col.bottom_offer?.title }}</p>
                  <p class="text-[9px] font-bold opacity-80 truncate mt-0.5" [style.color]="col.title_color || col.text_color || '#333'">{{ col.bottom_offer?.subtitle }}</p>
                </div>
                @if (collectionOfferImages(col).length) {
                <div class="flex items-center space-x-[-10px] shrink-0 ml-3">
                  @for (url of collectionOfferImages(col); track $index) {
                  <div class="h-8 w-8 rounded-full border-2 border-white shadow-sm bg-slate-50 overflow-hidden relative transition-transform hover:scale-110 hover:z-10" [style.z-index]="$index">
                    <img [src]="url" class="h-full w-full object-cover" alt="" />
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
            @default {
            <div class="mx-2.5 mb-3 rounded-2xl bg-white/95 backdrop-blur-xl px-3 py-2 flex items-center justify-between shadow-[0_4px_16px_rgba(0,0,0,0.06)] border relative overflow-hidden group" [style.border-color]="col.border_color || 'rgba(255,255,255,0.6)'">
              <div class="absolute inset-0 translate-x-[-100%] bg-gradient-to-r from-transparent via-white/50 to-transparent group-hover:animate-[shimmer_2s_infinite]"></div>

              <div class="flex-1 min-w-0 z-10">
                <p class="text-[11px] font-black leading-tight truncate text-slate-800">{{ col.bottom_offer?.title }}</p>
                <p class="text-[9px] font-bold opacity-75 truncate text-slate-500 mt-0.5">{{ col.bottom_offer?.subtitle }}</p>
              </div>
              @if (collectionOfferImages(col).length) {
              <div class="flex items-center gap-1.5 shrink-0 z-10 ml-3">
                @for (url of collectionOfferImages(col); track $index) {
                <div class="h-8 w-8 rounded-[10px] overflow-hidden bg-slate-50 border border-slate-100 shadow-sm flex items-center justify-center p-0.5">
                  <img [src]="url" class="h-full w-full object-contain" alt="" />
                </div>
                }
              </div>
              }
            </div>
            }
            }
            }

            @if (col.show_bottom_border) {
            <div
              class="collection-edge collection-edge-bottom"
              [ngStyle]="getCollectionEdgeStyle(col, 'bottom')"
            ></div>
            }
          </div>
          } @case ('featured_cards') {
          <div class="my-4">
            @if (getSectionConfig(section).title) {
            <h4 class="text-[22px] font-bold text-slate-900 px-4 mb-3">
              {{ getSectionConfig(section).title }}
            </h4>
            }
            <div class="flex gap-3 overflow-x-auto no-scrollbar px-4">
              @for (item of getSectionConfig(section).items; track $index) {
              <div
                class="w-[300px] h-[170px] rounded-3xl shrink-0 relative overflow-hidden group/feat cursor-pointer border border-black/5"
                [style.background]="item.background_color || '#f1f5f9'"
              >
                <img
                  [src]="item.image_url"
                  class="absolute inset-0 w-full h-full object-contain transition-transform duration-700 group-hover/feat:scale-105"
                  alt=""
                />
                <div
                  class="absolute inset-0 p-[18px] flex flex-col justify-between"
                >
                  @if (item.badge) {
                  <span
                    class="w-fit bg-blue-600 text-white text-[11px] font-bold px-2.5 py-1 rounded-full mb-2"
                    >{{ item.badge }}</span
                  >
                  }
                  <h5
                    class="w-[60%] text-slate-800 font-bold text-[22px] leading-[26px]"
                  >
                    {{ item.title }}
                  </h5>
                  @if (item.subtitle) {
                  <p
                    class="w-[58%] text-[13px] font-medium text-slate-600 mt-1.5 line-clamp-2"
                  >
                    {{ item.subtitle }}
                  </p>
                  }
                </div>
              </div>
              }
            </div>
          </div>
          } @case ('promo_carousel') {
          <div class="my-3">
            @if (getSectionConfig(section).title) {
            <h4 class="text-lg font-extrabold text-slate-900 px-4 mb-3">
              {{ getSectionConfig(section).title }}
            </h4>
            }
            <div class="flex gap-4 overflow-x-auto no-scrollbar px-4">
              @for (card of getSectionConfig(section).cards || [{}, {}]; track
              $index) {
              <div
                class="w-[351px] h-40 rounded-2xl p-4 relative overflow-hidden flex flex-col justify-center shrink-0 border"
                [style.background]="card.background_color || '#FFE6E6'"
                [style.border-color]="card.border_color || 'transparent'"
              >
                <div
                  class="absolute -right-6 -top-6 size-40 bg-white/20 blur-3xl rounded-full"
                ></div>
                <h3
                  class="text-lg font-extrabold relative z-10 leading-[22px] w-[58%]"
                  [style.color]="card.text_color || '#0f172a'"
                >
                  {{ card.title || 'Super Savings Day' }}
                </h3>
                <p
                  class="text-xs font-medium mt-1 relative z-10 w-[58%] opacity-70"
                  [style.color]="card.text_color || '#0f172a'"
                >
                  {{ card.subtitle || 'Shop for ₹999 & get free gift' }}
                </p>
                <div class="mt-3 flex items-center gap-2 relative z-10">
                  <button
                    class="bg-slate-900 text-white px-4 py-2 rounded-[10px] text-xs font-black active:scale-95 transition-transform"
                  >
                    {{ card.cta_text || 'Shop now' }} →
                  </button>
                </div>
                @if (card.image_url) {
                <img
                  [src]="card.image_url"
                  class="absolute right-[-20px] top-0 w-[48%] h-full object-contain"
                  alt=""
                />
                }
              </div>
              }
            </div>
            <div class="flex justify-center gap-1.5 mt-3">
              <span class="w-5 h-1 rounded-full bg-[#FF6B6B]"></span
              ><span class="w-1.5 h-1 rounded-full bg-slate-300"></span>
            </div>
          </div>
          } @case ('hero_showcase') { @let hero =
          getHeroShowcaseConfig(section);
          <div
            class="hero-showcase-container overflow-hidden"
            [class.premium-ui]="hero.ui_type === 'premium'"
            [class.modern-ui]="hero.ui_type === 'modern'"
            [class.classic-ui]="hero.ui_type === 'classic'"
            [class.festival-ui]="hero.ui_type === 'festival'"
            [style.background-color]="hero.container.background_color"
            [style.border-radius.px]="hero.container.border_radius || 24"
            [style.padding.px]="hero.container.padding || 16"
            [class.shadow-xl]="hero.container.shadow"
          >
            <!-- Layout: banner_top_cards_bottom -->
            @if (hero.layout_type === 'banner_top_cards_bottom') {
            <div class="flex flex-col gap-4">
              <!-- Banner -->
              <div
              class="hero-banner-main rounded-[1.5rem] overflow-hidden relative group"
              >
                <img
                  [src]="
                    hero.banner.image_url ||
                    'https://images.unsplash.com/photo-1498049794561-7780e7231661?q=80&w=800'
                  "
                  class="w-full h-auto object-contain"
                  alt=""
                />
                <div
                  class="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent p-6 flex flex-col justify-center"
                >
                  <h3 class="text-xl font-black text-white leading-tight mb-1">
                    {{ hero.banner.title }}
                  </h3>
                  <p class="text-xs font-bold text-white/80 mb-3">
                    {{ hero.banner.subtitle }}
                  </p>
                  <button
                    class="w-fit px-4 py-2 bg-white text-black text-[10px] font-black rounded-xl"
                  >
                    {{ hero.banner.cta_text }}
                  </button>
                </div>
              </div>
              <!-- Cards -->
              <div class="grid grid-cols-3 gap-3">
                @for (card of hero.cards; track $index) {
                <div
                  class="hero-small-card aspect-square rounded-2xl p-3 flex flex-col justify-between relative overflow-hidden"
                  [style.background-color]="card.background_color || '#fff'"
                >
                  <div class="relative z-10">
                    <p
                      class="text-[9px] font-black text-slate-800 leading-tight"
                    >
                      {{ card.title }}
                    </p>
                    @if (card.badge) {
                    <span
                      class="inline-block mt-1 text-[7px] font-black bg-indigo-100 text-indigo-600 px-1.5 py-0.5 rounded-md"
                      >{{ card.badge }}</span
                    >
                    }
                  </div>
                  <div class="absolute bottom-1 right-1 size-12 opacity-80">
                    <img
                      [src]="
                        card.image_url ||
                        'https://cdn-icons-png.flaticon.com/512/3659/3659898.png'
                      "
                      class="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                </div>
                }
              </div>
            </div>
            }

            <!-- Layout: banner_left_cards_right -->
            @if (hero.layout_type === 'banner_left_cards_right') {
            <div class="flex gap-3">
              <!-- Left Banner -->
              <div
                class="w-[60%] rounded-[1.5rem] overflow-hidden relative"
              >
                <img
                  [src]="
                    hero.banner.image_url ||
                    'https://images.unsplash.com/photo-1542496658-e33a6d0d50f6?q=80&w=800'
                  "
                  class="w-full h-auto object-contain"
                  alt=""
                />
                <div
                  class="absolute inset-0 bg-black/30 p-5 flex flex-col justify-end"
                >
                  <h3 class="text-lg font-black text-white leading-tight mb-1">
                    {{ hero.banner.title }}
                  </h3>
                  <p class="text-[10px] font-bold text-white/90 mb-3">
                    {{ hero.banner.subtitle }}
                  </p>
                  <button
                    class="w-fit px-3 py-1.5 bg-white text-black text-[9px] font-black rounded-lg"
                  >
                    {{ hero.banner.cta_text }}
                  </button>
                </div>
              </div>
              <!-- Right Cards Column -->
              <div class="flex-1 flex flex-col gap-3">
                @for (card of hero.cards; track $index) {
                <div
                  class="flex-1 rounded-2xl p-3 flex items-center justify-between relative overflow-hidden border border-black/5"
                  [style.background-color]="card.background_color || '#fff'"
                >
                  <div class="relative z-10">
                    <p class="text-[10px] font-black text-slate-800">
                      {{ card.title }}
                    </p>
                    @if (card.badge) {
                    <span class="text-[8px] font-bold text-indigo-600">{{
                      card.badge
                    }}</span>
                    }
                  </div>
                  <div class="size-10 shrink-0">
                    <img
                      [src]="
                        card.image_url ||
                        'https://cdn-icons-png.flaticon.com/512/3659/3659898.png'
                      "
                      class="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                </div>
                }
              </div>
            </div>
            }

            <!-- Layout: banner_top_grid -->
            @if (hero.layout_type === 'banner_top_grid') {
            <div class="space-y-3">
              <div
                class="hero-banner-main rounded-[1.5rem] overflow-hidden relative"
              >
                <img
                  [src]="hero.banner.image_url"
                  class="w-full h-auto object-contain"
                  alt=""
                />
                <div
                  class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-5"
                >
                  <h3 class="text-lg font-black text-white">
                    {{ hero.banner.title }}
                  </h3>
                  <p class="text-[10px] font-bold text-white/70">
                    {{ hero.banner.subtitle }}
                  </p>
                </div>
              </div>
              <div class="grid grid-cols-2 gap-3">
                @for (card of hero.cards; track $index) {
                <div
                  class="rounded-2xl p-4 flex gap-3 items-center"
                  [style.background-color]="card.background_color || '#fff'"
                >
                  <div class="size-12 rounded-xl bg-slate-50 p-2 shrink-0">
                    <img
                      [src]="card.image_url"
                      class="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                  <div>
                    <p
                      class="text-[11px] font-black text-slate-800 leading-tight"
                    >
                      {{ card.title }}
                    </p>
                    <span class="text-[9px] font-bold text-slate-400">{{
                      card.badge
                    }}</span>
                  </div>
                </div>
                }
              </div>
            </div>
            }

            <!-- Layout: banner_background_cards_overlay -->
            @if (hero.layout_type === 'banner_background_cards_overlay') {
            <div
              class="aspect-square rounded-[2rem] overflow-hidden relative p-5 flex flex-col justify-between"
            >
              <img
                [src]="
                  hero.banner.image_url ||
                  'https://images.unsplash.com/photo-1540317580114-ed684c0582ff?q=80&w=800'
                "
                class="absolute inset-0 w-full h-full object-contain"
                alt=""
              />
              <div class="absolute inset-0 bg-black/40"></div>

              <div class="relative z-10">
                <h3
                  class="text-2xl font-black text-white leading-none tracking-tighter"
                >
                  {{ hero.banner.title }}
                </h3>
                <p
                  class="text-xs font-bold text-amber-400 mt-1 uppercase tracking-widest"
                >
                  {{ hero.banner.subtitle }}
                </p>
              </div>

              <div
                class="relative z-10 flex gap-3 overflow-x-auto no-scrollbar py-2"
              >
                @for (card of hero.cards; track $index) {
                <div
                  class="w-28 h-32 bg-white/10 backdrop-blur-md rounded-2xl p-3 shrink-0 border border-white/20 flex flex-col justify-between"
                >
                  <div class="size-14 bg-white/20 rounded-xl p-2 self-center">
                    <img
                      [src]="card.image_url"
                      class="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                  <div class="text-center">
                    <p
                      class="text-[9px] font-black text-white leading-tight truncate"
                    >
                      {{ card.title }}
                    </p>
                    <p class="text-[8px] font-bold text-amber-300 mt-0.5">
                      {{ card.badge }}
                    </p>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
          } }
        </div>
        }
      </div>
      }

      @if (previewMode === 'home' && !selectedPreviewCategory) {
      <!-- Native Style Bottom Tab Bar -->
      <div
        class="shrink-0 min-h-[68px] bg-white border-t border-white/40 flex justify-around items-center px-4 pb-2 relative z-30 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      >
        <button
          type="button"
          class="flex-1 flex flex-col items-center"
          [class.text-slate-900]="!showCategoriesPreview"
          [class.text-slate-500]="showCategoriesPreview"
          (click)="openHomePreview()"
        >
          <div class="h-[18px] flex items-center justify-center">
            <i class="fi fi-rr-shopping-bag text-lg"></i>
          </div>
          <span class="text-xs mt-1" [class.font-bold]="!showCategoriesPreview"
            >Home</span
          >
          @if (!showCategoriesPreview) {
          <div
            class="w-[22px] h-[3px] rounded-full bg-slate-900 mt-1.5"
          ></div>
          }
        </button>
        <button
          type="button"
          class="flex-1 flex flex-col items-center"
          [class.text-slate-900]="showCategoriesPreview"
          [class.text-slate-500]="!showCategoriesPreview"
          (click)="openCategoriesPreview()"
        >
          <i class="fi fi-rr-apps text-lg"></i>
          <span
            class="text-xs mt-1"
            [class.font-bold]="showCategoriesPreview"
            [class.font-medium]="!showCategoriesPreview"
            >Categories</span
          >
          @if (showCategoriesPreview) {
          <div
            class="w-[22px] h-[3px] rounded-full bg-slate-900 mt-1.5"
          ></div>
          }
        </button>
        @if (dynamicBottomTab) {
        <button
          type="button"
          class="flex-1 flex items-center justify-center min-w-0"
          [attr.aria-label]="dynamicBottomTab.label"
        >
          <div
            class="w-[108px] h-10 px-2 rounded-[22px] flex items-center justify-center overflow-hidden"
            [style.background-color]="dynamicBottomTab.background_color || '#FFECEC'"
          >
            @if (dynamicBottomTab.icon_url || dynamicBottomTab.collection_icon_url) {
            <img
              [src]="dynamicBottomTab.icon_url || dynamicBottomTab.collection_icon_url"
              [alt]="dynamicBottomTab.label"
              class="max-w-full h-[25px] object-contain"
            />
            } @else {
            <span
              class="text-[11px] font-bold truncate"
              [style.color]="dynamicBottomTab.text_color || '#111111'"
              >{{ dynamicBottomTab.label }}</span
            >
            }
          </div>
        </button>
        }
      </div>
      }

      <!-- Home Indicator -->
      <div
        class="absolute bottom-2 left-1/2 -translate-x-1/2 w-32 h-1.5 bg-slate-200 rounded-full z-40 opacity-50"
      ></div>
    </div>
  </div>
</div>

<ng-template #customerProductCard let-product="product" let-imageHeight="imageHeight">
  <div class="customer-product-card bg-white overflow-hidden rounded-xl">
    <div class="rounded-xl border border-[#E2E5EB] bg-[#F8F9FC] overflow-hidden">
      <div
        class="relative flex items-center justify-center overflow-hidden bg-[#F8F9FC]"
        [style.height.px]="imageHeight || 128"
      >
        <img
          [src]="productImage(product)"
          [alt]="product.name || 'Product'"
          class="w-[96%] h-[96%] object-contain"
        />
        @if (productDiscount(product) > 0) {
        <span class="absolute top-1.5 left-1.5 z-20 rounded-full bg-[#E31C79] px-[5px] py-[3px] text-[8px] leading-none font-extrabold text-white">
          {{ productDiscount(product) }}% OFF
        </span>
        }
        <span class="absolute top-1.5 right-1.5 z-20 size-[25px] flex items-center justify-center text-slate-900">
          <i class="fi fi-rr-heart text-[17px]"></i>
        </span>
        @if (product.food_type && product.food_type !== 'not_applicable') {
        <span
          class="absolute bottom-1.5 left-1.5 z-20 size-[10px] border flex items-center justify-center bg-white"
          [ngClass]="product.food_type === 'non_veg' ? 'border-red-600' : 'border-green-700'"
        >
          <span
            class="size-1 rounded-full"
            [ngClass]="product.food_type === 'non_veg' ? 'bg-red-600' : 'bg-green-700'"
          ></span>
        </span>
        }
      </div>
      <div class="h-[38px] pl-2 pr-1.5 border-t border-[#E2E5EB] bg-white flex items-center justify-between gap-1">
        <span class="min-w-0 flex-1 truncate text-[11px] leading-[15px] font-bold text-slate-900">
          {{ product.unit || product.quantity || '1 unit' }}
        </span>
        <span
          class="min-w-[55px] h-8 px-2 rounded-[9px] border-[1.5px] border-[#318616] bg-white flex flex-col items-center justify-center text-[#318616]"
        >
          <span class="text-xs leading-3 font-extrabold tracking-wide">ADD</span>
          @if (product.variantCount > 1 || product.variants?.length > 1) {
          <span class="text-[7px] leading-[8px] font-extrabold">
            {{ product.variantCount || product.variants.length }} options
          </span>
          }
        </span>
      </div>
    </div>

    <div class="px-[7px] pt-2 pb-2">
      <div class="flex items-baseline gap-[5px] min-w-0">
        <span class="text-base leading-5 font-extrabold text-slate-900">₹{{ product.price }}</span>
        @if (product.mrp > product.price) {
        <span class="truncate text-[11px] leading-[15px] text-[#8A93A0] line-through">₹{{ product.mrp }}</span>
        }
      </div>
      @if (productDiscount(product) > 0) {
      <p class="mt-[3px] text-[10px] leading-[13px] font-extrabold text-blue-600">
        {{ productDiscount(product) }}% OFF on MRP
      </p>
      }
      <p class="mt-1.5 min-h-[34px] text-xs leading-4 font-semibold text-slate-900 line-clamp-2">
        {{ product.name }}
      </p>
      @if (productFeaturedHighlight(product); as highlight) {
      <p class="mt-[7px] max-w-full min-h-5 w-fit rounded-md bg-[#FFF4CC] px-[7px] flex items-center text-[9px] leading-3 font-bold text-[#7A5700] truncate">
        {{ highlight }}
      </p>
      }
      @if (product.rating > 0) {
      <div class="mt-[7px] flex items-center gap-[3px] text-[10px] leading-[13px] font-medium text-slate-500">
        <i class="fi fi-sr-star text-[11px] text-[#F6BE25]"></i>
        <span>{{ product.rating | number : '1.1-1' }}</span>
      </div>
      }
    </div>
  </div>
</ng-template>
